import { render, staticRenderFns } from "./VinculosFormaPagamento.vue?vue&type=template&id=7589ec72&"
import script from "./VinculosFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./VinculosFormaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./VinculosFormaPagamento.vue?vue&type=style&index=0&id=7589ec72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports